export const DNI = 'DNI';
export const NIE = 'NIE';
export const TIE = 'TIE';
export const PASSPORT = 'PASSPORT';
